export class ClientError extends Error {
  readonly message: string;

  constructor(body: any) {
    const msg = `${body.error_code}: ${body.message} ${body.extra}`;
    super(msg);
    this.message = msg;
  }
}
